import { render } from "./Posts.vue?vue&type=template&id=0a5ff0e2&ts=true"
import script from "./Posts.vue?vue&type=script&lang=ts"
export * from "./Posts.vue?vue&type=script&lang=ts"

import "./Posts.vue?vue&type=style&index=0&id=0a5ff0e2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__